import { __awaiter } from "tslib";
import { RcsbFvCoreBuilder } from "./RcsbFvCoreBuilder";
import { RcsbFvDataProvider } from "../RcsbFvModule/RcsbFvDataProvider";
import { GroupPfvUI } from "../../RcsbFvUI/GroupPfvUI";
export class RcsbFvDataProviderBuilder {
    static buildFv(elementId, additionalConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var _a, _b;
                try {
                    RcsbFvCoreBuilder.createFv({
                        elementId,
                        fvModuleI: RcsbFvDataProvider,
                        config: {
                            resolve,
                            additionalConfig
                        }
                    });
                    GroupPfvUI.fvUI(GroupPfvUI.addBootstrapElement(elementId), (additionalConfig === null || additionalConfig === void 0 ? void 0 : additionalConfig.externalUiComponents) ? [...((_a = additionalConfig.externalUiComponents.add) !== null && _a !== void 0 ? _a : []), ...((_b = additionalConfig.externalUiComponents.replace) !== null && _b !== void 0 ? _b : [])] : []);
                }
                catch (e) {
                    reject(e);
                }
            });
        });
    }
}
//# sourceMappingURL=RcsbFvDataProviderBuilder.js.map